<template>
  <div class="">
    <el-form :model="form" :rules="rules" ref="form">
      <TopBarTitleComponent title="Categorías" :showBackIcon="showBackIcon">
        <template slot="right-area">
          <div class="d-flex justify-content-end align-items-center">
            <ButtonPrimaryComponent
              title="Guardar"
              @onSaveClick="handleSaveClick"
            />
          </div>
        </template>
      </TopBarTitleComponent>

      <div class="dir-content-body">
        <b-row>
          <b-col>
            <div class="card box-shadow">
              <div class="card-body">
                <b-row>
                  <b-col xs="12" sm="12" md="6">
                    <el-form-item prop="image">
                      <FileUploadComponent
                        title="Subir imagen"
                        :preview="form.image"
                        :showFileList="false"
                        :drag="true"
                        @fileBase64="onFileBase64"
                      />
                    </el-form-item>
                    <el-form-item prop="title">
                      <slot name="label">
                        <label class="font-semi-bold m-0"
                          >Nombre Categoría</label
                        >
                      </slot>
                      <el-input type="text" v-model="form.title"></el-input>
                    </el-form-item>
                    <el-form-item prop="description">
                      <slot name="label">
                        <label class="font-semi-bold m-0"
                          >Descripción de la categoría</label
                        >
                      </slot>
                      <el-input
                        type="textarea"
                        rows="8"
                        resize="none"
                        v-model="form.description"
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="6"></b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import TopBarTitleComponent from "../../../components/TopBarTitle";
import ButtonPrimaryComponent from "../../../components/ButtonPrimary";
import FileUploadComponent from "../../../components/FileUpload";
import Validate from "@/assets/validate";

import catalogueService from "../../services/catalogueService";

export default {
  name: "CategoryAddComponent",
  data: () => ({
    apiResponse: {
      message: null
    },
    form: {
      title: "",
      description: "",
      image: null
    },
    rules: {
      title: [Validate.rules.required()]
      // description: [Validate.rules.required()]
    }
  }),
  computed: {},
  methods: {
    onFileBase64(base64) {
      this.form.image = base64;
    },
    onChangeInput(data) {
      this.form = { ...this.form, ...data };
    },
    handleSaveClick() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.$store.dispatch("toggleRequestLoading");
          try {
            let response = await catalogueService
              .addCategories(this.form)
              .finally(() => {
                this.$store.dispatch("toggleRequestLoading");
              });
            const { success, message, category } = response.data;
            if (success) {
              this.$refs.form.resetFields();
              this.$notifications.success({
                message
              });
              this.$emit("onSuccess", { category });
            }
          } catch (error) {
            return false;
          }
        }
      });
    }
  },
  components: {
    TopBarTitleComponent,
    ButtonPrimaryComponent,
    FileUploadComponent
  },
  props: {
    showBackIcon: {
      default: true,
      type: Boolean
    }
  }
};
</script>

<style></style>
